<template>
    <div class="message-item__content--select-age">
        <div class="select-age text"
            @click="showPicker">
            {{content}}
        </div>
    </div>
</template>

<script>
    import { inObjectValues } from '@/utils'

    const MODE = {
        AGE: 'age',
        MONEY: 'money',
        DATE: 'date'
    }

    export default {
        name: 'MessageContentSelect',
        props: {
            mode: {
                type: String,
                required: true,
                validator (value) {
                    return inObjectValues(MODE, value)
                }
            },
            content: {
                type: String,
                required: true,
                validator (value) {
                    return value.trim() !== ''
                }
            }
        },
        methods: {
            showPicker () {
                this.$eventBus.$emit(`SHOW_${this.mode}_PICKER`)
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../css/content_text";

    .message-item__content--select-age {
        .select-age.text {
            color: $primary-color;
            cursor: pointer;
        }
    }

</style>
